import React, { ReactElement, InputHTMLAttributes } from 'react';

import { DataCollectionValuesKey } from '../../../hooks';

interface FormControlProps {
    tag: string;
    type?: string;
    name: DataCollectionValuesKey;
    id: string;
    placeholder?: string;
    defaultValue?: string;
    props?: InputHTMLAttributes<HTMLInputElement | HTMLSelectElement>;
    className?: string;
    onChange: React.ChangeEventHandler<HTMLInputElement | HTMLSelectElement>;
    onBlur: React.FocusEventHandler<HTMLInputElement | HTMLSelectElement>;
    value: string;
    error?: string | boolean | undefined;
    options?: {
        value: string;
        title: string;
    }[];
    tooltip?: string;
    readonly?: boolean;
    min?: number;
    max?: number;
}

const FormControl = ({
    tag,
    name,
    id,
    type,
    className,
    placeholder,
    defaultValue,
    readonly,
    options,
    tooltip,
    min,
    max,
    ...props
}: FormControlProps): ReactElement<'div'> | null => {
    const validationStateClass = !props.error ? 'wiz-form-container--success' : 'wiz-form-container--error';
    const validationClass = props.value != '' ? validationStateClass : '';
    const customClass = className || '';
    const containerClass =
        tag === 'select'
            ? ['wiz-form-container wiz-form-container--select', validationClass, customClass].join(' ')
            : ['wiz-form-container', validationClass, customClass].join(' ');
    return (
        <div className={`${containerClass}`}>
            {tag === 'input' && (
                <>
                    <input
                        className="wiz-form-control"
                        id={id}
                        type={type || 'text'}
                        name={name}
                        {...props}
                        readOnly={readonly}
                        min={min || (type === 'number' ? 0 : '')}
                        max={max}
                    />
                </>
            )}
            {tag === 'select' && options && options.length > 0 && (
                <select name={name} id={id} {...props} className="wiz-form-control">
                    if (placeholder){' '}
                    {
                        <option value="" disabled>
                            {placeholder}
                        </option>
                    }
                    {options.map((option, index) => {
                        return (
                            <option key={`select-${id}-option-${index}`} value={option.value}>
                                {option.title}
                            </option>
                        );
                    })}
                </select>
            )}
            {tooltip && (
                <div className={'tooltip'} data-tip={tooltip}>
                    <img src="/img/layout/tooltip.svg" alt="Tooltip" />
                </div>
            )}
        </div>
    );
};

export default FormControl;
